var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005CA9",
    d: "M4.5 0A4.5 4.5 0 0 0 0 4.5v2.379q.117.042.228.096l19.794 9.555c.618.3 1.338.3 1.956 0l19.794-9.555.228-.096V4.5A4.5 4.5 0 0 0 37.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005CA9",
    d: "M42 11.862 23.934 20.58a6.75 6.75 0 0 1-5.868 0L0 11.862V25.5A4.5 4.5 0 0 0 4.5 30h33a4.5 4.5 0 0 0 4.5-4.5z"
  })));
};
export default SvgMail;